import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ChooseLogo } from '@/components/ui/choose-logo';
import { trackEvent } from '@/lib/mixpanel';

export default function HomePage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('page.home.title');
  }, [t]);

  useEffect(() => {
    trackEvent('HOME_VIEWED');
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background to-muted">
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <ChooseLogo width={90} height={90} />
        </div>
        <h1
          data-testid="choose-title"
          className="text-4xl font-bold tracking-tight"
        >
          {t('page.home.title')}
        </h1>
      </div>
    </div>
  );
}
